import React from 'react';
import { Box } from '@wds/box';
import useStyles from './useStyles';
import SocialProofLogos from './Logos';

export default function Grow2427SocialProof(): JSX.Element {
  const { SocialProof } = useStyles();

  return (
    <Box className={SocialProof}>
      <div className="trusted-text">Trusted by</div>
      <SocialProofLogos />
    </Box>
  );
}
